import { Box, BoxProps, styled } from "@mui/material";
import { CarYearField } from "@app/components/Inputs";
import { UseYearRangeSelector } from "./useYearRangeSelector";

const StyledYearField = styled(CarYearField)(({ theme }) => ({
  width: 140,
  // margin: "auto",
  ".MuiInputLabel-root": {
    fontSize: "16px",
  },
  ".MuiInputBase-root": {
    backgroundColor: theme.palette.white,
  },
}));

interface YearRangeSelectorProps extends BoxProps {
  isWhiteContext?: boolean;
  yearRangeSelector: UseYearRangeSelector;
}

export const YearRangeSelector = ({
  yearRangeSelector,
  isWhiteContext,
  ...props
}: YearRangeSelectorProps) => {
  const { fromYear, toYear, startYear, setStartYear, endYear, setEndYear } =
    yearRangeSelector;

  return (
    <Box {...props} sx={{ display: "flex", gap: 3.5, ...props.sx }}>
      <StyledYearField
        sx={{
          ".MuiInputBase-root": {
            backgroundColor: isWhiteContext ? "gray1" : "white",
          },
        }}
        label="Start Year"
        range={{ fromYear, toYear }}
        value={startYear}
        onChange={setStartYear}
      />
      <StyledYearField
        sx={{
          ".MuiInputBase-root": {
            backgroundColor: isWhiteContext ? "gray1" : "white",
          },
        }}
        label="End Year"
        range={{ fromYear, toYear }}
        value={endYear}
        onChange={setEndYear}
      />
    </Box>
  );
};
